<script setup lang="ts">
import { cn } from '@pokerly/ui';
import type { HTMLAttributes } from 'vue';
interface Props {
    class?: HTMLAttributes['class'];
}

const props = defineProps<Props>();
</script>

<template>
    <div :class="cn(props.class, 'relative', 'flex', 'flex-col', 'justify-center', 'items-center')">
        <div class="absolute flex justify-center w-full h-full overflow-hidden">
            <div
                :class="
                    cn(
                        'absolute',
                        'z-0',
                        'w-480',
                        'h-200',
                        'rounded-[50%]',
                        'mt-16',
                        'bg-linear-180 from-manaca-700 from-0% to-manaca-900 to-28%',
                    )
                "
            ></div>
        </div>
        <div class="z-1 p-4">
            <slot></slot>
        </div>
    </div>
</template>

<style scoped></style>
